// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rwords {
  display: flex;

  margin-top: 10rem;
  margin-left: 15rem;
}
.content {
  position: absolute;

  transform: translate(-50%, -50%);
  overflow: hidden;

  font-size: 85px;
  line-height: 1em;
  color: #6ccfe8;

  justify-self: center;
  align-self: center;
}

.content__container {
  font-weight: 600;
  overflow: hidden;
  height: 1.3em;
}

.content:before {
  content: '<';
  left: 1.5rem;
}

.content:after {
  content: '/>';
  padding-left: 10rem;
  right: 0rem;
}

.content:after,
.content:before {
  position: absolute;
  top: 0;

  color: #16a085;

  line-height: 1.5em;

  -webkit-animation-name: opacity;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  animation-name: opacity;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.content__container__text {
  display: inline;

  margin: 0;
}

.content__container__list {
  margin-top: 0;

  list-style: none;

  -webkit-animation-name: change;
  -webkit-animation-duration: 10s;
  -webkit-animation-iteration-count: infinite;
  animation-name: change;
  animation-duration: 10s;
  animation-iteration-count: infinite;
}
.content__container__list__item {
  padding: 0.2em;
  padding-right: 1.2em;
  padding-left: 0.8em;
}

@media screen and (max-width: 767px) {
  .content {
    transform: translate(-50%, -50%);
    overflow: hidden;

    font-size: 3rem;
    line-height: 1em;
    color: rgb(34 211 238);
    align-items: center;
    justify-content: center;
    align-self: center;
    justify-self: center;
  }

  .rwords {
    width: 100%;
    margin-left: 10.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 9rem;
    margin-bottom: 2rem;
  }
}

@keyframes opacity {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@keyframes change {
  0%,
  22%,
  100% {
    transform: translate3d(0, 0, 0);
  }
  25%,
  47% {
    transform: translate3d(0, -33%, 0);
  }
  50%,
  72% {
    transform: translate3d(0, -66%, 0);
  }
  75%,
  97% {
    transform: translate3d(0, -33%, 0);
  }
}
/*
// 6 is the number of animation.
// Here, there are 4 lines :

// 1 to 2
// 2 to 3
// 3 to 4
// 4 to 3
// 3 to 2
// 2 to 1

// 6x + 6y = 100 (100% duration)

// HERE : 
// y = 4 -> Animation between two lines
// x = 12.66 -> Time spent on a line

// You can define a value and calculate the other if you want change speed or the number of lines
*/
`, "",{"version":3,"sources":["webpack://./src/Styles/RotatingWords.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;;EAElB,gCAAgC;EAChC,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;;EAEN,cAAc;;EAEd,kBAAkB;;EAElB,+BAA+B;EAC/B,8BAA8B;EAC9B,2CAA2C;EAC3C,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,eAAe;;EAEf,SAAS;AACX;;AAEA;EACE,aAAa;;EAEb,gBAAgB;;EAEhB,8BAA8B;EAC9B,+BAA+B;EAC/B,2CAA2C;EAC3C,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;IACE,gCAAgC;IAChC,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AA4FA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;;IAGE,+BAA+B;EACjC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,kCAAkC;EACpC;AACF;AACA;;;;;;;;;;;;;;;;;;CAkBC","sourcesContent":[".rwords {\r\n  display: flex;\r\n\r\n  margin-top: 10rem;\r\n  margin-left: 15rem;\r\n}\r\n.content {\r\n  position: absolute;\r\n\r\n  transform: translate(-50%, -50%);\r\n  overflow: hidden;\r\n\r\n  font-size: 85px;\r\n  line-height: 1em;\r\n  color: #6ccfe8;\r\n\r\n  justify-self: center;\r\n  align-self: center;\r\n}\r\n\r\n.content__container {\r\n  font-weight: 600;\r\n  overflow: hidden;\r\n  height: 1.3em;\r\n}\r\n\r\n.content:before {\r\n  content: '<';\r\n  left: 1.5rem;\r\n}\r\n\r\n.content:after {\r\n  content: '/>';\r\n  padding-left: 10rem;\r\n  right: 0rem;\r\n}\r\n\r\n.content:after,\r\n.content:before {\r\n  position: absolute;\r\n  top: 0;\r\n\r\n  color: #16a085;\r\n\r\n  line-height: 1.5em;\r\n\r\n  -webkit-animation-name: opacity;\r\n  -webkit-animation-duration: 2s;\r\n  -webkit-animation-iteration-count: infinite;\r\n  animation-name: opacity;\r\n  animation-duration: 2s;\r\n  animation-iteration-count: infinite;\r\n}\r\n\r\n.content__container__text {\r\n  display: inline;\r\n\r\n  margin: 0;\r\n}\r\n\r\n.content__container__list {\r\n  margin-top: 0;\r\n\r\n  list-style: none;\r\n\r\n  -webkit-animation-name: change;\r\n  -webkit-animation-duration: 10s;\r\n  -webkit-animation-iteration-count: infinite;\r\n  animation-name: change;\r\n  animation-duration: 10s;\r\n  animation-iteration-count: infinite;\r\n}\r\n.content__container__list__item {\r\n  padding: 0.2em;\r\n  padding-right: 1.2em;\r\n  padding-left: 0.8em;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .content {\r\n    transform: translate(-50%, -50%);\r\n    overflow: hidden;\r\n\r\n    font-size: 3rem;\r\n    line-height: 1em;\r\n    color: rgb(34 211 238);\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-self: center;\r\n    justify-self: center;\r\n  }\r\n\r\n  .rwords {\r\n    width: 100%;\r\n    margin-left: 10.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 9rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes opacity {\r\n  0%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes change {\r\n  0%,\r\n  22%,\r\n  100% {\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n  25%,\r\n  47% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n  50%,\r\n  72% {\r\n    transform: translate3d(0, -66%, 0);\r\n  }\r\n  75%,\r\n  97% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n}\r\n\r\n@-o-keyframes opacity {\r\n  0%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-o-keyframes change {\r\n  0%,\r\n  22%,\r\n  100% {\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n  25%,\r\n  47% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n  50%,\r\n  72% {\r\n    transform: translate3d(0, -66%, 0);\r\n  }\r\n  75%,\r\n  97% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n}\r\n\r\n@-moz-keyframes opacity {\r\n  0%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-moz-keyframes change {\r\n  0%,\r\n  22%,\r\n  100% {\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n  25%,\r\n  47% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n  50%,\r\n  72% {\r\n    transform: translate3d(0, -66%, 0);\r\n  }\r\n  75%,\r\n  97% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n}\r\n\r\n@keyframes opacity {\r\n  0%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes change {\r\n  0%,\r\n  22%,\r\n  100% {\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n  25%,\r\n  47% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n  50%,\r\n  72% {\r\n    transform: translate3d(0, -66%, 0);\r\n  }\r\n  75%,\r\n  97% {\r\n    transform: translate3d(0, -33%, 0);\r\n  }\r\n}\r\n/*\r\n// 6 is the number of animation.\r\n// Here, there are 4 lines :\r\n\r\n// 1 to 2\r\n// 2 to 3\r\n// 3 to 4\r\n// 4 to 3\r\n// 3 to 2\r\n// 2 to 1\r\n\r\n// 6x + 6y = 100 (100% duration)\r\n\r\n// HERE : \r\n// y = 4 -> Animation between two lines\r\n// x = 12.66 -> Time spent on a line\r\n\r\n// You can define a value and calculate the other if you want change speed or the number of lines\r\n*/\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
